import { render } from "./ChartDetail.vue?vue&type=template&id=b97c5c44&scoped=true"
import script from "./ChartDetail.vue?vue&type=script&lang=js"
export * from "./ChartDetail.vue?vue&type=script&lang=js"

import "./ChartDetail.vue?vue&type=style&index=0&id=b97c5c44&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97c5c44"]])

export default __exports__